const is_json_like_string = (value) => /^[\s]*[{[]/.test(String(value || ''));

const parse_json_string = (value, fallback = {}) => (
  is_json_like_string(value) ? JSON.parse(value) : fallback
);

export const parse_response_data = (response) => {
  const raw_data = response?.data ?? response ?? {};

  if (typeof raw_data !== 'string') {
    return raw_data;
  }

  const parsed_data = parse_json_string(raw_data);
  return typeof parsed_data === 'string' ? parse_json_string(parsed_data) : parsed_data;
};

export const extract_items = (response) => {
  const parsed = parse_response_data(response);
  const candidates = [
    parsed?.data?.results,
    parsed?.data?.projects,
    parsed?.data?.items,
    parsed?.data?.records,
    parsed?.data?.companies,
    parsed?.data?.data?.results,
    parsed?.data?.data?.projects,
    parsed?.data?.data,
    parsed?.data,
    parsed?.projects,
    parsed?.items,
    parsed?.records,
    parsed?.companies,
    parsed?.results,
    parsed
  ];

  return candidates.find((candidate) => Array.isArray(candidate)) || [];
};

export const normalize_collection = (response) => extract_items(response);

export const normalize_text = (value) => String(value || '').trim().toLowerCase();

export const title_case = (value) => {
  const text = String(value || '').trim();

  return text
    ? text
      .split(/\s+/)
      .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
      .join(' ')
    : '';
};

export const first_value = (values, fallback = '') => {
  const value = values.find((candidate) => candidate !== undefined && candidate !== null && candidate !== '');
  return value === undefined ? fallback : value;
};

const read_nested_property = (record, key) => (
  record && typeof record === 'object' ? Reflect.get(record, key) : undefined
);

export const first_nested_value = (record, paths, fallback = '') => {
  for (const path of paths) {
    const value = path.split('.').reduce((current, key) => read_nested_property(current, key), record);

    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }

  return fallback;
};
